import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-router-info',
  templateUrl: './router-info.component.html',
  styleUrls: ['./router-info.component.css']
,
  standalone: false
})
export class RouterInfoComponent implements OnInit {
  @Input() routerData:any;
  constructor() { }

  ngOnInit(): void {
  }

}